<template>
  <div class="statistic">
    <div class="value">
      <span v-if="saleState === 1">
        <span v-if="count.days">
          {{ count.days }} <span class="time">day<span v-if="count.days > 1">s</span></span>
        </span>
        <span v-if="count.hours">
          {{ count.hours }} <span class="time">hour<span v-if="count.hours > 1">s</span></span>
        </span>
        <span v-if="count.minutes">
          {{ count.minutes }} <span class="time">min<span v-if="count.minutes > 1">s</span></span>
        </span>
        <span v-if="count.minutes === 0 && remainingSeconds >= 0">
          {{ remainingSeconds }} seconds
        </span>
      </span>
      <span v-if="saleState === 2">
        <span v-if="count.days">
          {{ count.days }}
        </span>
        <span v-if="count.days === 0 && count.hours !== 0">
          {{ count.hours }}
        </span>
        <span v-if="count.hours === 0 && count.minutes !== 0">
          {{ count.minutes }}
        </span>
        <span v-if="count.minutes === 0">
          {{ remainingSeconds }} seconds
        </span>
      </span>
      <span v-if="saleState === 3">
        0 seconds
      </span>
    </div>
    <div class="label" v-if="saleState === 1">
      <div class="label" v-if="saleState === 1">to start</div>
    </div>
    <div class="label" v-if="saleState !== 1">
      <span v-if="count.days">
        <span class="time">day<span v-if="count.days > 1">s</span></span>
      </span>
      <span v-if="count.days === 0 && count.hours !== 0">
        <span class="time">hour<span v-if="count.hours > 1">s</span></span>
      </span>
      <span v-if="count.hours === 0 && count.minutes !== 0">
        <span class="time">min<span v-if="count.minutes > 1">s</span></span>
      </span>
    remaining
    </div>
    <small>Sale starts on block #{{ initialBlock }}</small>
    <span v-if="saleState !== 1">
      <small>Hidden cap revealed: 275,000 ether</small>
    </span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'countdown',
  computed: {
    count() {
      if (!this.$store.state.saleState.nextImportantTime) {
        return 0
      }

      const time = moment(this.$store.state.saleState.nextImportantTime)
      const diff = time.diff(moment.now())
      const duration = moment.duration(diff)
      return {
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      }
    },
    remainingSeconds() {
      return this.$store.state.saleState.remainingSeconds
    },
    saleState() {
      return 3
    },
    initialBlock() {
      return this.$store.state.stats.initialBlock
    },
    capRevealed() {
      return this.$store.state.stats.capRevealed
    },
    cap() {
      return this.$store.state.stats.cap
    },
  },
  mounted() {
    setInterval(() => {
      if (this.count.minutes < 1) {
        let remainingSeconds = this.$store.state.saleState.remainingSeconds
        if (remainingSeconds === -1) remainingSeconds = this.count.seconds
        if (remainingSeconds > 0) {
          this.$store.commit('setRemainingSeconds', remainingSeconds - 1)
        }
      }
    }, 1000)
  },
}
</script>

<style scoped>
small {
  font-weight: lighter;
  color: white;
  margin-top: 1rem;
}
.time {
  font-size: 2.5rem;
}
.statistic .label {
  margin-top: 0.75rem !important;
  font-size: 2.5rem;
}
</style>



// WEBPACK FOOTER //
// Countdown.vue?0542dcf5